//A
export enum AccessLevelEnum {
    AccountOwner = 1,
    Full = 2,
    Read = 4,
    None = 8
    //[Description("Täydet oikeudet")]
    //Full = Write & Read
}

export enum AuthenticationBankIdEnum {
    NOTSET = 0,
    NORDEA = 1,
    OSUUSPANKKI = 2,
    TAPIOLA = 3,
    SPANKKI = 4,
    DANSKEBANK = 5,
    AKTIA = 6,
    HANDELSBANKEN = 7,
    ALANDSBANKEN = 8,
    POPPankki = 9,
    SAASTOPANKKI = 10,
    OMASAASTOPANKKI = 11,
    KORHOPANKKI = 12,
    NORDEA2 = 13,
    MOBIILIVARMENNE = 100
}

export enum AuthenticationServiceTypeEnum {
    NOTDEFINED = 0,
    TUPAS = 1,
    ElisaTunnistus = 2,
    TeliaTunnistus = 3,
    OPTunnistus = 4,
    SuomiFi = 5
}
//B
//C
export enum CISContractStatusEnum {
    UNKNOWN = 0,
    ACTIVE = 1,
    EXPIRED = 2,
    UNFINISHED = 3,
    COMINGTOEND = 4,
    FUTURE = 5
}

export enum ContactPersonTypeEnum {
    UNKNOWN = 0,
    DIRECTOR = 1,
    WORK_RESPONSIBLE = 2,
    WORK_STARTING_PERMIT_RECEIVER = 3,
    SECURITY_SUPERVISOR = 4,
    SECURITY_SUPERVISOR_ASSISTANT = 5,
    SECURITY_GUARD = 6,
    READINESS_REPORTER = 7,
    NETWORK_CONTACT_PERSON = 8,
    ELECTRIC_DESIGNER = 9,
    HEATING_DESIGNER = 10,
    WATER_DESIGNER = 11
}

export enum ContractContactPersonTypeEnum {
    Undefined = 0,
    Trustee = 1, // inworks AL01
    ContractRepresentative = 2, // inworks AL02
    InvoicingRepresentative = 3, // inworks AL03
    CouplingRepresentative = 4, // inworks AL04
    OutageRepresentative = 5, // inworks AL05
    Other = 6 // inworks OTHR
}

export enum ContractReasonEnum {
    NOTDEFINED = 0,
    SUPPLIERCHANGE = 1,
    MOVEIN = 2,
    PRODUCTCHANGE = 3,
    NEWCONTRACT = 4,
    PRODUCTCHANGE_DH = 11,  // DataHub AT01 = Sopimuksen vaihto
    SUPPLIERCHANGE_DH = 12, // DataHub AT02 = Myyjän vaihto
    MOVEIN_DH = 13,         // DataHub AT03 = Sisäänmuutto
    NOTKNOWN = 99,      // with this status contract start date can be empty (sqlmindate in db)
}

export enum ContractTypeEnum {
    Unknown = 0,
    SalesContract = 1,
    NetworkContract = 2,
    ServiceContract = 3,
    ServiceConnectionContract = 4,
    ReconciliationContract = 5,
    ConsolidatedContract = 6,
    SupplyContract = 7,
    WholeSaleContract = 8,
    BackingContract = 9,
    PriceLimitContract = 10,
    PriceGuaranteedContract = 11,
    PurchaseContract = 12,
    NetworkProductionContract = 13,
    DistributionContract = 14
}

export enum DocumentTypeEnum {
    Invoice = 0,
    ContractConfirmation = 1,
    UserAttachment=2
}

export enum CustomerTypeEnum {
    CONSUMER = 1,
    COMPANY = 2,
    NOTSET = 0
}
//D
//E
//F
export enum FixedTermDurationUnit {
    DAYS = 0,
    MONTHS = 1,
    YEARS = 2,
}
//G
//H
export enum HeatingTypeEnum {
    ELECTRICITY = 1,
    NOELECTRICITY = 2,
    GEOTHERMAL = 3,
    DISTRICTHEATING = 4,
    OIL = 5,
    OTHER = 6,
    NOTKNOWN = 7,
    GAS = 8,
    ELECTRICSTORAGEHEATING = 9,
    DIRECTELECTRICHEATING = 10,
    WOODHEATING = 11,
    HEATPUMP = 12,
    NOHEATING = 13
}

export enum HousingTypeEnum {
    UNKNOWN = 0,
    APARTMENTHOUSE = 1,
    TERRACEDHOUSE = 2,
    HOUSE = 3,
    COTTAGE = 4,
    DOUBLEHOUSE = 5,
    OTHER = 6,
    INDUSTRIALBUILDING = 7,
    COMMERCIALBUILDING = 8,
    AGRICULTURALBUILDING = 9,
    CONCENTRATIONBUILDING = 10,
    SERVICESECTORBUILDING = 11,
    PUBLICSECTORBUILDING = 12,
    CONSTRUCTION = 13,
    RESIDENTIALPROPERTY = 14,
    COMMUNITYANDUTILITYSERVICE = 15,
    OUTDOORLIGHTNING = 16,
    ELECTRICVECHILECHARGING = 17,
    TRAFFIC = 18,
    INDUSTRIALBUILDING2 = 19,
    TERRACEDORDOUBLEHOUSE = 20
}
//I
//J
//K
//L
//M
export enum MeteringPointSourceEnum {
    UNKNOWN = 0,
    USER = 1,
    CIS = 2,
    ADATO = 3,
    USERCHANGED = 4,
    DATAHUB = 5
}

export enum MoveOutReasonEnum {
    MOVEOUT = 0,        // Ulosmuutto
    TERMINATION = 1,    // Irtisanominen
    CANCELLATION = 2,   // Purkaminen
    REMOVEDMETER = 3,   // Mittarin poisto
    NOTKNOWN = 99,      // Ulosmuutto
}
//N
//O
//P
export enum PartTimeHousingTypeEnum {
    FULLTIME = 1,
    HALFTIME = 2,
    SUMMER = 3,
}

export enum PhoneNumberTypeEnum {
    Home = 0,
    Work = 1,
    Mobile = 2,
    Invoicing = 3
}

// There's no enum in DataModel for these. However, they are actually fixed and those numbers are used
// everywhere in the code. Let's user an enum here for clarity.
export enum ProductComponentTypeEnum {
    BasicMonthly = 1,
    Energy1 = 2,
    Energy2 = 3,
    Energy3 = 4,
    Energy4 = 5,
    ProductionMonthly = 6,
    ReactiveBasic = 7,
    Energy1Bundle = 8,
    Energy2Bundle = 9,
    BasicYearly = 10,
    Other = 11,
    Service = 12
}

export enum ProcessStatusEnum {
    UNKNOWN = 0,
    MANUAL = 1,
    CUSTOMERCREATED = 2,
    PROCESSHANDLED = 3,
    OFFER = 4,
    OFFERACCEPTED = 5,
    MOVEOUTCREATED = 6,
    CONTRACTCREATED = 7,
    NOTTOCIS = 8,
    TOCIS = 9,
    OFFERREJECTED = 10,
    ERROR = 99,
}

export enum ProcessTypeEnum {
    UNKNOWN = 0,
    CONTRACTPROCESS = 1,
    MOVINGPROCESS = 2,
    FIXEDTIME = 3,
    CONNECTIONPROCESS = 4,
    MOVEOUT = 5,
    REGISTRATION = 6,
    CHANGEUSERNAME = 7,
    CUSTOMERINFORMATION = 8,
    CONTRACTCHANGEPROCESS = 9,
    OTHERCONTRACTPROCESS = 10,
    CONTRACTINVOICINGPROCESS = 11,
}

export enum SubProcessTypeEnum {
    UNKNOWN = 0,
    CONTRACTUPDATE = 1,
    MOVINGWITHOLDCONTRACTPRODUCT = 2,
    OFFER = 3,
    PRODUCTIONPURCHASECONTRACT = 4
}

export enum ProductTypeEnum {
    NORMAL = 0,
    BUNDLE = 1,
    SERVICE = 2
}

//Q
//R
export enum RuleTypeEnum {
    CONSUMPTION = 1,
    MEMBER = 2,
    FUSESIZE = 3,
    TARIFICATION = 4,
    LOCATION = 5,
    VISIBILITY = 6,
    CUSTOMERTYPE = 7,
}
//S
//T
export enum TarificationIdEnum {
    SINGLETARIF = 1,
    DAYNIGHTTARIF = 2,
    SEASONTARIF = 3,
    POWERDAYTARIF = 4,
    HEATING = 5,
    WATER = 6,
    GAS = 7,
    POWERSEASONTARIF = 8,
    DISTRICTCOOLING = 9,
    GENERALENERGY = 10
}

export enum TariffTimeZoneIdEnum {
    SINGLETIME = 1,
    NIGHT = 2,
    DAY = 3,
    WINTERDAY = 4,  // Talviarkipäivä 1.11. - 1.4. 07 - 22
    OTHER = 5,      // Muu aika 1.4. - 1.11. ja 1.11. - 1.4. 22 - 07
    POWERDAY = 6,   //
    WINTEROTHER = 7, //
    SUMMEROTHER = 8, //
    POWERWINTER = 9, //Talvi,1.11-31.03,00-24
    POWERSUMMER = 10, //Kesä,1.4-31.10,00-24
    POWERNIGHT = 11,
    POWERWORKINGDAY = 12
}
//U
export enum UserMappingAccessLevelEnum {
    None = 0,
    Read = 1,
    Full = 2
}

export enum InvoicingMethodEnum {
    Paper = 0,
    ConsumerEInvoice = 1,
    CompanyEInvoice = 2,
    Email = 3,
    DirectPayment = 4,
    Online = 5,
    Print = 6,
    MobilePay = 7
}
export enum UserProfileFeatureTypeEnum {
    DefaultReportingMeteringPointCode = 0,
    RepresentedCompanyName = 1,
    RepresentedCompanyBic = 2,
    FacebookUserId = 3,
    SourceCompanyCode = 4,
    GoogleUserToken = 5,
    MarketingPermissionAskedTime = 6,
    ContactDetailsChecked = 7,
    PID = 8,
}

export enum UtilityTypeEnum {
    NotDefined = 0,
    Electricity = 1,
    DistrictHeat = 2,
    DistrictCooling = 3,
    Gas = 4,
    Water = 5,
    WasteWater = 6,
    StormWater = 7,
    Stream = 8,
    Other = 9,
    SprinklerWater = 10,
    ElectricityTax = 11,
    ElectricityProduction = 12
}

//V
//W
export enum WebModule {
    NotSet = 0,
    Invoicing = 1,
    CustomerInformation = 2,
    Contacts = 3,
    Contracts = 4,
    Outages = 5,
    Reports = 6,
    /// <summary>
    /// This webmodule rights cannot be shared so only AccountOwner can access this webmodule
    /// </summary>
    User = 7,
    VipCard = 8,
    Messages = 9,
    ReadingEntry = 10,
    Connections = 11
}

//X
//Y
//Z




